import React, { useState, useRef, useEffect } from "react";
import styles from "./index.module.scss";
import { useRouter } from "next/router";

const ArticleDropdown = ({ articleDropdownData = {} }) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const router = useRouter();
  const { locale } = router;
  const handleToggle = () => setOpen(true);
  useEffect(() => {
    if (!open) return;
    function handleClickOutside(event) {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const heading = articleDropdownData.heading || "";
  const items = articleDropdownData.item || [];
  const showBorder = true;

  return (
    <div className={styles.wrapper}>
      <div className="koh-article-header">
        <div className="koh-article-controls contained">
          {heading && (
            <button
              ref={buttonRef}
              className={`koh-article-select${open ? " open" : ""}`}
              onClick={handleToggle}
              type="button"
            >
              {heading}
            </button>
          )}
          {items.length > 0 && (
            <ul className={`koh-article-set${open ? " open" : ""}`}>
              {items.map((item, idx) =>
                item?.fields?.label && item?.fields?.url ? (
                  <li key={item.sys?.id || idx}>
                    <a
                      className={item.active ? "active" : ""}
                      href={locale === "default" ? `/en${item.fields.url}` : `/${locale}${item.fields.url}`}
                    >
                      {item.fields.label}
                    </a>
                  </li>
                ) : null
              )}
            </ul>
          )}
        </div>
      </div>
      <div className="koh-article-controls contained">
        <div
          className={showBorder ? styles.cardDivider : styles.cardDivide}
        ></div>
      </div>
    </div>
  );
};
ArticleDropdown.defaultProps = {
  articleDropdownData: {
    heading: "",
    items: [],
  },
};
export default ArticleDropdown;
